import React from "react";
import { Button, Grid, Modal, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import Correct from "../../images/Correct.svg";
import Incorrect from "../../images/Incorrect.svg";
import styles from "./styles";
import "animate.css/animate.css";

const NextSetModal = ({
  classes,
  questionSetIndex,
  handleNextSet,
}) => {
  return (
    <Modal open={true}>
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Grid className={`${classes.evaluatorModalContainer}`}>
          <Grid container justify="center">
            {`Congratulations!`}
          </Grid>
          <Typography className={classes.evalDesc}>
            Ready for the next Stage?
          </Typography>
          <Grid container justify="center">
            <Button className={classes.submitButton} onClick={handleNextSet}>
              NEXT
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default withStyles(styles)(NextSetModal);
